import React from 'react'
import CommunitySettingsContainer from '../../Containers/CommunitySettings'
function index() {
  return (
    <CommunitySettingsContainer/>
  )
}

export default index